import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.case-study-slider').forEach((section) => {
        const sliderContainer = section.querySelector('.css-mainwrap.swiper');
        if (!sliderContainer) { return; }

        new Swiper(sliderContainer, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            autoHeight: true,

            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },

            speed: 700,

            navigation: {
                prevEl: section.querySelector('.arrow-prev'),
                nextEl: section.querySelector('.arrow-next'),
            },

            pagination: {
                el: section.querySelector('.css-pagination'),
                clickable: true,
            },

            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
        });
    });
});
